export function errorMessage(error: unknown): string {
  if (error instanceof Error) return error.message;
  return '操作失败。';
}

export function initialOf(name: string): string {
  return (Array.from(name.trim())[0] ?? '?').toUpperCase();
}
